import * as LabelPrimitive from '@radix-ui/react-label';
import * as React from 'react';
import { cn } from '../lib/cn';

export const Input = React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(({ className, ...props }, ref) => (
  <input
    ref={ref}
    className={cn('h-11 w-full rounded-lg border border-line bg-surface px-3 text-[15px] text-ink placeholder:text-ink-3',
      'focus:border-tick focus:outline-none focus:ring-2 focus:ring-tick/25 aria-[invalid=true]:border-bad', className)}
    {...props}
  />
));
Input.displayName = 'Input';

export const Label = React.forwardRef<React.ElementRef<typeof LabelPrimitive.Root>, React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root>>(
  ({ className, ...props }, ref) => <LabelPrimitive.Root ref={ref} className={cn('text-[13px] font-semibold text-ink-2', className)} {...props} />,
);
Label.displayName = 'Label';
